import script from "./FriendsHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./FriendsHeader.vue?vue&type=script&setup=true&lang=js"

import "./FriendsHeader.vue?vue&type=style&index=0&id=09dea834&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09dea834"]])

export default __exports__